
<script>
import { Carousel, Slide } from 'vue-carousel';
import Loader from '../components/Loader';
import LeaderboardSelector from '../components/LeaderboardSelector';

export default {
    components: {
        Carousel,
		Slide,
		Loader,
		LeaderboardSelector,
    },
    data() {
        return {
            selectedLeaderboardIndex: 0,
            leaderboards: ['Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond'],
            selectedPeriodIndex: 0,
            periods: ['Today', 'This Week', 'This Month', 'This Year', 'All Time'],
            ranks: [],
			perPage: 20,
			pages: [],
			isLoading: false,
            myRank: {},
        };
    },

	watch: {
        ranks() {
            this.setPages();
		},
	},

    async mounted() {
        await this.init();
	},

    methods: {

		async left() {
			if (this.selectedLeaderboardIndex > 0) {
				// Allow the Leaderboard Selector to move left
				this.selectedLeaderboardIndex -= 1;
				await this.init();
			}
		},

		async right() {
			if (this.selectedLeaderboardIndex < this.leaderboards.length - 1) {
				// Allow the Leaderboard Selector to move right
				this.selectedLeaderboardIndex += 1;
				await this.init();
			}
		},

		async init() {
			this.ranks = [];
			this.isLoading = true;
			this.ranks = await this.getRanks();

            if (this.$store.getters.isAuthenticated) {
                this.myRank = await this.getMyRank();
            }
            
			this.isLoading = false;
		},

		setPages() {
            const pageCount = Math.ceil(this.ranks.length / this.perPage);
            this.pages = [];
            for (let index = 1; index <= pageCount; index += 1) {
                this.pages.push(index);
            }
        },

        paginate(page) {
            const { perPage } = this;
            const from = page * perPage - perPage;
            const to = page * perPage;
            return this.ranks.slice(from, to);
        },

        filterByUser(user) {
            this.$router.push('/?search=' + user);
        },

        async getRanks() {
            const response = await window.axios.get('/api/leaderboards/', {
                params: {
                    leaderboard: this.leaderboards[this.selectedLeaderboardIndex],
                    period: this.periods[this.selectedPeriodIndex],
                },
			});
            return response.data.data;
        },

        async getMyRank() {
            const response = await window.axios.get('/api/leaderboards/', {
                params: {
                    leaderboard: this.leaderboards[this.selectedLeaderboardIndex],
                    period: this.periods[this.selectedPeriodIndex],
                    me: true,
                },
			});
            return response.data.data;
        },

        getTooltipText(row) {
            const levelText = {
                1: 'Bronze', 
                2: 'Silver',
                3: 'Gold',
                4: 'Platinum',
                5: 'Diamond',
            };

            let privileges = row.is_moderator ? 'Moderator' : 'Regular';
            privileges = row.is_admin ? 'Administrator' : privileges;

            return `This user has ${privileges} account privileges and has a current status of ${levelText[row.profilestatus]}`;
        },
    },
};
</script>

<template lang="pug" src="./template/SideLeaderboards.pug"></template>
<style lang="stylus" src="./styles/SideLeaderboards.styl" scoped></style>
